package com.example.webcv.pages.portfolio.model

val portfolioItems = listOf(
        PortfolioItem(
                "QrCraft",
                "Android",
                "/icons/qrCraft.png",
                "Android",
                "https://github.com/galahseno/QRCraft",
        ),
        PortfolioItem(
                "NoteMark",
                "Android",
                "/icons/notemark.png",
                "Android",
                "https://github.com/extractive-mana-pulse/NoteMark",
        ),
        PortfolioItem(
                "Collapsible Chat Thread",
                "Android",
                "/icons/chatThread.jpg",
                "Android",
                "https://gist.github.com/extractive-mana-pulse/2afd533ca179dd95175cf2295cadd631",
        ),
        PortfolioItem(
                "Rich Text Editor",
                "Android",
                "/icons/rich_text_editor.png",
                "Android",
                "https://github.com/extractive-mana-pulse/RichTextEditor",
        ),
        PortfolioItem(
                "Lazy Pizza",
                "Android",
                "/icons/lazy_pizza.png",
                "Android",
                "https://github.com/icdominguez/LazyPizza",
        ),
        PortfolioItem(
                "All In One",
                "Android",
                "/icons/default_ic.png",
                "Android",
                "https://github.com/extractive-mana-pulse/All-In-One",
        )
    )